
import { Star } from "lucide-react";

const testimonials = [
  {
    content:
      "Scaloo a complètement transformé notre stratégie de médias sociaux. Nous créons de meilleurs contenus en moitié moins de temps, et nos taux d'engagement ont explosé.",
    author: "Alexis Chen",
    role: "Directeur Marketing",
    company: "TechFusion",
  },
  {
    content:
      "En tant qu'entrepreneur individuel, je ne pouvais pas gérer efficacement ma présence sur les réseaux jusqu'à ce que je découvre Scaloo. Maintenant, je publie régulièrement du contenu de qualité sur toutes les plateformes.",
    author: "Marcus Johnson",
    role: "Fondateur",
    company: "Artisan Ecommerce",
  },
  {
    content:
      "La fonction de modération des commentaires à elle seule fait gagner plusieurs heures par semaine à notre équipe. L'IA est remarquablement efficace pour identifier les commentaires qui nécessitent notre attention.",
    author: "Sophia Rodriguez",
    role: "Community Manager",
    company: "Lifestyle Brand Co.",
  },
];

const TestimonialsSection = () => {
  return (
    <section className="bg-white py-24">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-indigo-600 bg-indigo-50 rounded-full">Témoignages</span>
          <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Adopté par les équipes marketing
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Découvrez ce que nos clients disent de la façon dont Scaloo a transformé leur présence sur les réseaux sociaux.
          </p>
        </div>

        <div className="mx-auto mt-16 grid max-w-lg gap-8 lg:max-w-none lg:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="flex flex-col justify-between rounded-2xl border border-gray-200 bg-white p-8 shadow-sm"
            >
              <div>
                <div className="mb-6 flex">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className="h-5 w-5 text-yellow-400 fill-current"
                    />
                  ))}
                </div>
                <p className="mb-8 text-gray-700">"{testimonial.content}"</p>
              </div>
              <div className="flex items-center">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-indigo-100 text-indigo-600">
                  {testimonial.author.charAt(0)}
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-900">
                    {testimonial.author}
                  </p>
                  <p className="text-xs text-gray-600">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
